export type ThemeName = 'light' | 'dark';

export const THEME_KEY = 'bc_theme_v2';

export function systemTheme(): ThemeName {
  try {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  } catch {
    return 'light';
  }
}

export function getTheme(): ThemeName {
  try {
    const raw = localStorage.getItem(THEME_KEY);
    if (raw === 'light' || raw === 'dark') return raw;
  } catch {

  }
  return 'light';
}

export function setTheme(theme: ThemeName): ThemeName {
  const next = theme === 'dark' ? 'dark' : 'light';
  try {
    localStorage.setItem(THEME_KEY, next);
  } catch {

  }
  document.documentElement.setAttribute('data-theme', next);
  return next;
}

export function toggleTheme(): ThemeName {
  return setTheme(getTheme() === 'dark' ? 'light' : 'dark');
}

export function applyStoredTheme(): ThemeName {
  return setTheme(getTheme());
}
